import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import { UserRoleService } from '../../services/user-role.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-customer-service-environment',
  templateUrl: './customer-service-environment.component.html',
  styleUrls: ['./customer-service-environment.component.scss']
})
export class CustomerServiceEnvironmentComponent implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  // cseForm:FormGroup;
  // leanerName:FormControl;
  // centerName:FormControl;
  customerServicesForm: any
  jobData
  learnerData
  learnerName
  customerServicesedit
  sign1: boolean
  sign2: boolean
  sign3: boolean
  sign4: boolean
  loading = false
  currentUser: any;
  user: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerServices: LearnerService,
    public _userRoleService : UserRoleService
  ) { }

  ngOnInit() {
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes..................", changes);

    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue[0]
      this.getUserRole();
      // this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList", this.jobData);
    }
    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue
      this.learnerName = this.learnerData.name
      console.log("learner name ==============>", this.learnerName)
    }
    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.customerServicesedit = changes.assessmentEdit.currentValue
      console.log("assement =============>", this.customerServicesedit)

      this.customerServicesedit = changes.assessmentEdit.currentValue
      console.log("edit form value", this.customerServicesedit);
      let size = Object.keys(this.customerServicesedit).length;
      console.log("what is the size of object", size);

      if (size != 0) {


        if (this.customerServicesedit && this.customerServicesedit.customerServicesForm) {
          if (this.customerServicesedit.customerServicesForm && this.customerServicesedit.customerServicesForm.sign1 != "") {
            this.sign1 = true
          }
          if (this.customerServicesedit.customerServicesForm && this.customerServicesedit.customerServicesForm.sign2 != "") {
            this.sign2 = true
          }
          if (this.customerServicesedit.customerServicesForm && this.customerServicesedit.customerServicesForm.sign3 != "") {
            this.sign3 = true
          }
          if (this.customerServicesedit.customerServicesForm && this.customerServicesedit.customerServicesForm.sign4 != "") {
            this.sign4 = true
          }
        }
        // this.selectedTrainer = this.specimanEdit.specimanForm.trainer
        this.createForm(this.customerServicesedit)
      }

    }

  }
  getUserRole(){
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors,'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if(getRole.isLearner) this.isLearner = true
    else if(getRole.isTrainer) this.isTrainer = true
    else if(getRole.isIQA) this.isIQA = true

  }
  createForm(details?) {
    this.customerServicesForm = new FormGroup({
      learnerName: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.learnerName : this.learnerName),
      centerName: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.centerName : ''),
      ev1: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev1 : ''),
      ev2: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev2 : ''),
      ev3: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev3 : ''),
      ev4: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev4 : ''),
      ev5: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev5 : ''),
      ev6: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev6 : ''),
      ev7: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev7 : ''),
      ev8: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev8 : ''),
      ev9: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev9 : ''),
      ev10: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev10 : ''),
      ev11: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev11 : ''),
      ev12: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev12 : ''),
      ev13: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev13 : ''),
      ev14: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev14 : ''),
      ev15: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev15 : ''),
      ev16: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev16 : ''),
      ev17: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev17 : ''),
      ev18: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev18 : ''),
      ev19: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev19 : ''),
      ev20: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev20 : ''),
      ev21: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev21 : ''),
      ev22: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev22 : ''),
      ev23: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev23 : ''),
      ev24: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev24 : ''),
      ev25: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev25 : ''),
      ev26: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev26 : ''),
      ev27: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev27 : ''),
      ev28: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.ev28 : ''),
      assesorName: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.assesorName : ''),
      sign1: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.sign1 : ''),
      leanerName1: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.learnerName : this.learnerName),
      sign2: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.sign2 : ''),
      iqaName: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.iqaName : ''),
      sign3: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.sign3 : ''),
      eqaName: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.eqaName : ''),
      sign4: new FormControl((details && details.customerServicesForm) ? details.customerServicesForm.sign4 : '')
      // ev1: new FormControl(''),

    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  // UTILITY

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  addSignature(fomrControl) {
    if ((this.isTrainer || this.isIQA) && (fomrControl == 'sign1')) {
    }
    else if ((this.isLearner || this.isIQA) && (fomrControl == 'sign2')) {
      // this.exerciseReferral.get('learnerSign').disable()
    }
    else if ((this.isLearner || this.isTrainer) && (fomrControl == 'sign3')) {
      // this.exerciseReferral.get('assesorSign4').disable()
    } 
    else if (this.isLearner && (fomrControl === 'sign4')) {

    }
    else {
      this.openDialog(SignaturePadComponent).subscribe((data) => {
        console.log("data of sign", data);
        if (data == undefined) return

        let sign = data

        // if (formType == 'trackMaintenance') {
        if (fomrControl == 'sign1') {
          this.sign1 = true
          this.customerServicesForm.patchValue({
            sign1: sign
          })
        }
        if (fomrControl == 'sign2') {
          this.sign2 = true
          this.customerServicesForm.patchValue({
            sign2: sign
          })
        }
        // } else if (formType == 'techCert') {
        if (fomrControl == 'sign3') {
          this.sign3 = true
          this.customerServicesForm.patchValue({
            sign3: sign
          })
        }
        if (fomrControl == 'sign4') {
          this.sign4 = true
          this.customerServicesForm.patchValue({
            sign4: sign
          })
        }
        // }
      })
    }
  }



  // ***********************
  // submit form 
  // ************************
  submitCustomberServices() {
    console.log("display services submit form=====================>", this.customerServicesForm.value)
    this.loading = true

    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        customerServicesForm: this.customerServicesForm.value
      }
    }

    console.log("data customber servuces =============>", data)
    this._learnerServices.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })

  }

}
